import {DomainObject} from 'shared/store';
import { observable, computed, action, makeObservable } from 'mobx';
import Question from './Question';
import {t} from 'shared/core';
import _ from 'lodash';

class PositionRule extends DomainObject {
  id;
  question = null;
  disqualifiers = [];

  _relations = {
    question: Question
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      question: observable,
      disqualifiers: observable,
      validate: action,
      formattedDisqualifiers: computed
    });

    this.merge(other);
  }

  validate() {
    const errors = {};

    if (_.isEmpty(this.disqualifiers)) {
      errors.disqualifiers = t('recruiting.edit.steps.errors.position_rule.Must select at least one disqualifier');
    }
    if (!this.question) {
      errors.question = t("recruiting.edit.steps.errors.position_rule.Question can't be blank");
    }

    return errors;
  }

  get formattedDisqualifiers() {
    return _.join(this.disqualifiers, ', ');
  }
}

export default PositionRule;
